import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../src/images/logoDocLift.png";
import userIcon from "../../src/images/user.svg";
import { getDataFromLocalStorage } from "../util/localStorage";
import AI_PDF_CONST from "../util/PdfAiConst";

const marketingLinks = [
  { label: "Services", href: "/home#what-doclift-does" },
  { label: "Industries", href: "/home#industries" },
  { label: "Trust", href: "/home#trust" },
];

const resourceLinks = [
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
];

const Header = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const useFullWidthHeader = location.pathname !== "/home2";

  useEffect(() => {
    setUserInfo(getDataFromLocalStorage("userInfo"));
    setMenuOpen(false);
  }, [location]);

  const logout = () => {
    localStorage.clear();
    setMenuOpen(false);
    navigate("/login");
  };

  return (
    <header className={`glass-header fixed top-0 z-50 w-full ${useFullWidthHeader ? "glass-header-full" : ""}`}>
      <div className="glass-header-shell mx-auto mt-3 flex min-h-[58px] max-w-[1180px] items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to={AI_PDF_CONST.ROUTE.HOME} className="glass-logo-link flex items-center">
          <img className="h-[30px] w-auto" src={logo} alt="DocLift" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {marketingLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="glass-nav-link text-sm font-semibold text-[#26384d]"
            >
              {link.label}
            </a>
          ))}
          {resourceLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="glass-nav-link text-sm font-semibold text-[#26384d]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          {userInfo ? (
            <>
              <NavLink
                to="/my-docs"
                className={({ isActive }) =>
                  `glass-account-link inline-flex min-h-[40px] items-center rounded-md px-4 text-sm font-bold ${
                    isActive
                      ? "text-[#0f8c5f]"
                      : "text-[#34465a]"
                  }`
                }
              >
                Workspace
              </NavLink>
              <div className="account-menu group relative">
                <button className="glass-user-button flex min-h-[40px] items-center gap-2 rounded-full border border-[#dfe8ef] bg-white/70 px-2 py-1">
                  <img
                    src={userInfo.userProfileImg || userIcon}
                    alt={userInfo?.name || "User"}
                    className="h-8 w-8 rounded-full object-cover"
                  />
                  <span className="max-w-[120px] truncate pr-2 text-sm font-semibold text-[#26384d]">
                    {userInfo?.name || "Account"}
                  </span>
                </button>
                <div className="glass-dropdown invisible absolute right-0 top-full w-[220px] rounded-lg border border-white/55 bg-white/85 p-2 opacity-0 shadow-xl transition group-hover:visible group-hover:opacity-100">
                  <div className="border-b border-[#edf2f7] px-3 py-2">
                    <p className="truncate text-sm font-bold text-[#18324d]">
                      {userInfo?.name || "DocLift User"}
                    </p>
                    <p className="truncate text-xs text-[#6c7a89]">
                      {userInfo?.email || "Signed in"}
                    </p>
                  </div>
                  <Link
                    to="/my-docs"
                    className="mt-2 block rounded-md px-3 py-2 text-sm font-semibold text-[#34465a] hover:bg-[#f3f7fb]"
                  >
                    My Docs
                  </Link>
                  <button
                    onClick={logout}
                    className="block w-full rounded-md px-3 py-2 text-left text-sm font-semibold text-[#b42318] hover:bg-[#fff1f0]"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="glass-account-link inline-flex min-h-[40px] items-center rounded-md px-4 text-sm font-bold text-[#34465a]"
              >
                Login
              </Link>
              <Link
                to="/login"
                className="glass-start-button inline-flex min-h-[40px] items-center rounded-md bg-[#13a66f] px-5 text-sm font-bold text-white"
              >
                Get Started
              </Link>
            </>
          )}
        </div>

        <button
          type="button"
          className="glass-menu-button inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/55 text-[#18324d] lg:hidden"
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? (
            <span className="text-sm font-bold">Close</span>
          ) : (
            <span className="flex flex-col gap-1">
              <span className="block h-[2px] w-5 bg-current" />
              <span className="block h-[2px] w-5 bg-current" />
              <span className="block h-[2px] w-5 bg-current" />
            </span>
          )}
        </button>
      </div>

      {menuOpen && (
        <div className="glass-mobile-menu mx-4 mt-2 rounded-lg border border-white/55 bg-white/85 px-4 py-4 shadow-lg lg:hidden">
          <nav className="grid gap-1">
            {[...marketingLinks, ...resourceLinks].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="rounded-md px-3 py-3 text-sm font-bold text-[#34465a] hover:bg-[#f3f7fb]"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="mt-4 grid gap-2 border-t border-[#edf2f7] pt-4">
            {userInfo ? (
              <>
                <Link
                  to="/my-docs"
                  className="rounded-md bg-[#13a66f] px-3 py-3 text-center text-sm font-bold text-white"
                >
                  Open Workspace
                </Link>
                <button
                  onClick={logout}
                  className="rounded-md border border-[#f5c2bd] px-3 py-3 text-sm font-bold text-[#b42318]"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="rounded-md border border-[#dfe8ef] px-3 py-3 text-center text-sm font-bold text-[#34465a]"
                >
                  Login
                </Link>
                <Link
                  to="/login"
                  className="rounded-md bg-[#13a66f] px-3 py-3 text-center text-sm font-bold text-white"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
